import { Box, SxProps, Theme } from '@mui/material'
import { Currency } from '../../types/models'

export interface SymProps {
  currency: Currency
  sx?: SxProps<Theme>
}

/**
 * Convert currency to symbol.
 */
export const Sym = (props: SymProps): JSX.Element => {
  const { currency } = props
  const sx = {
    ...props.sx
  }

  let sym: string
  switch (currency) {
    case 'EUR':
      sym = '€'
      break
    default:
      throw new Error(`Unsupported currency symbol '${currency}'.`)
  }

  return <Box component="span" sx={sx}>{sym}</Box>
}
